import React, { useEffect, useState } from 'react'
import { PropTypes } from 'prop-types'

import PortableText from '../../portableText'
import useForm from '../../../hooks/useForm'
import TTMarketoForm from '../../Marketo/TTMktoForm'
import {
	MaturityCalculatorBtn,
	MaturityCalculatorContainer,
	MaturityCalculatorFieldSet,
	MaturityCalculatorOption,
} from './MaturityCalculator.styles'

export default function MaturityCalculator({ title, maturityCalcReference, ttmarketoForm }) {
	const { rows } = maturityCalcReference
	const totalQs = rows.length

	const { values, updateValue } = useForm({})
	const [count, setCount] = useState(0)
	const [disabled, setDisabled] = useState(true)

	// 8 hidden values were set-up in Marketo Form to capture scores from user input
	const [results, setResults] = useState({
		p2PMaturityAssessmentQ1INT: 0,
		p2PMaturityAssessmentQ2INTEGER: 0,
		p2PMaturityAssessmentQ3INT: 0,
		p2PMaturityAssessmentQ4INT: 0,
		p2PMaturityAssessmentQ5INT: 0,
		p2PMaturityAssessmentQ6INT: 0,
		p2PMaturityAssessmentQ7INT: 0,
		P2P_Maturity_Assessment_Score__c: 0,
	})

	const revealNext = () => {
		if (!disabled) {
			setCount(count + 1)
		}
	}

	const revealPrev = () => {
		setCount(count - 1)
	}

	useEffect(() => {
		if (values[count] === undefined) {
			setDisabled(true)
			return
		}
		setDisabled(false)
	}, [values, count])

	useEffect(() => {
		if (Object.entries(values).length === totalQs) {
			const newValues = { ...values }
			for (const [key, value] of Object.entries(newValues)) {
				newValues[key] = parseInt(value)
			}
			const totalScore = Object.values(newValues).reduce((prevValue, currentValue) => prevValue + currentValue)
			newValues[Object.keys(newValues).length] = totalScore

			if (Object.keys(newValues).length === Object.keys(results).length) {
				Object.keys(results).forEach((key, index) => {
					results[key] = newValues[index]
				})
				setResults(results)
			}
		}
	}, [values, totalQs])

	return (
		<MaturityCalculatorContainer>
			{title ? <h2>{title}</h2> : null}
			<article>
				{count < totalQs && (
					<>
						<label htmlFor="progress-bar">
							Progress: {count + 1}/{totalQs} <br />
							<progress id="progress-bar" value={(count * 100) / totalQs} max="100" />
						</label>
						<p>
							Choose the answer that best describes the prevailing current state for the majority of
							cases.
						</p>
					</>
				)}
				{rows.slice(count, count + 1).map((row) =>
					row.question && row.question.length !== 0 && row.options && row.options.length !== 0 ? (
						<MaturityCalculatorFieldSet key={row._key}>
							<legend>
								<PortableText blocks={row.question} />
							</legend>
							{row.options.map((option, index) => (
								<MaturityCalculatorOption key={option._key}>
									<input
										type="radio"
										name={count}
										value={option.score}
										onChange={updateValue}
										checked={index === parseInt(values[count])}
									/>
									{option.choice}
								</MaturityCalculatorOption>
							))}
						</MaturityCalculatorFieldSet>
					) : null
				)}
			</article>

			{count === 0 && (
				<MaturityCalculatorBtn>
					<button type="button" onClick={revealNext} aria-disabled={disabled}>
						Next
					</button>
				</MaturityCalculatorBtn>
			)}
			{count > 0 && count < totalQs && (
				<MaturityCalculatorBtn>
					<button type="button" onClick={revealPrev}>
						Back
					</button>
					<button type="button" onClick={revealNext} aria-disabled={disabled}>
						Next
					</button>
				</MaturityCalculatorBtn>
			)}
			{count === totalQs && (
				<>
					{ttmarketoForm && <TTMarketoForm {...ttmarketoForm} hiddenValues={results} />}
					<MaturityCalculatorBtn>
						<button type="button" onClick={revealPrev}>
							Back
						</button>
					</MaturityCalculatorBtn>
				</>
			)}
		</MaturityCalculatorContainer>
	)
}

MaturityCalculator.propTypes = {
	title: PropTypes.string,
	maturityCalcReference: PropTypes.object,
	ttmarketoForm: PropTypes.object,
}
